import { actionCreator } from "../../helpers/redux/actionCreator";
import * as ActionTypes from "./types";

export const setMenu = actionCreator(ActionTypes.SET_MENU)
export const setMenuItems = actionCreator(ActionTypes.SET_MENU_ITEMS)
export const setMenuActiveItem = actionCreator(ActionTypes.SET_MENU_ACTIVE_ITEM)
export const setMenuActiveId = actionCreator(ActionTypes.SET_MENU_ACTIVE_ID)
export const setDrawerOpen = actionCreator(ActionTypes.SET_DRAWER_OPEN)
export const setMenuSelectedItems = actionCreator(ActionTypes.SET_MENU_SELECTED_ITEMS)
export const setMenuSelectedLevel = actionCreator(ActionTypes.SET_MENU_SELECTED_LEVEL)
